module.exports = __webpack_public_path__ + "static/media/Male Doctor - Default img.b0e5ac38.png";